import { exportToXlsx, type ExportColumn } from '@spcc/core'
import type { SubCustomerAudience, SubCustomerExportRow } from '../types'
import { AUDIENCE_CONFIG, SUB_CUSTOMER_T_KEYS as K, SUB_CUSTOMER_WORDING as W, wordingKey } from '../constants'

type Translate = (key: string) => string

const MAIN_CUSTOMER_KEY: keyof SubCustomerExportRow = 'customerName'

export function buildSubCustomerExportColumns(t: Translate, audience: SubCustomerAudience): ExportColumn<SubCustomerExportRow>[] {
  const columns: ExportColumn<SubCustomerExportRow>[] = [
    { header: t(K.EXPORT.COL_ORDER_NUMBER), key: 'orderNumber', width: 16 },
    { header: t(K.EXPORT.COL_DELIVERY_DAY), key: 'deliveryDay', width: 14 },
    { header: t(wordingKey(audience, W.ENTITY)), key: 'subCustomerName', width: 28 },
    { header: t(wordingKey(audience, W.CODE)), key: 'subCustomerCode', width: 16 },
    { header: t(K.MAIN_CUSTOMER), key: MAIN_CUSTOMER_KEY, width: 28 },
    { header: t(K.CITY), key: 'city', width: 18 },
    { header: t(K.PLANT), key: 'plant', width: 20 },
    { header: t(K.CEMENT_TYPE), key: 'cementType', width: 24 },
    { header: t(K.TONS), key: 'tons', width: 12 },
  ]
  if (AUDIENCE_CONFIG[audience].showMainCustomer) return columns
  return columns.filter((column) => column.key !== MAIN_CUSTOMER_KEY)
}

export interface ExportSubCustomerOrdersOptions {
  rows: SubCustomerExportRow[]
  audience: SubCustomerAudience
  from: string
  to: string
  t: Translate
}

export function exportSubCustomerOrders({ rows, audience, from, to, t }: ExportSubCustomerOrdersOptions): void {
  exportToXlsx({
    fileName: `${AUDIENCE_CONFIG[audience].exportFilePrefix}-${from}_${to}`,
    sheetName: t(K.EXPORT.SHEET),
    columns: buildSubCustomerExportColumns(t, audience),
    rows,
  })
}
